const rnds8 = new Uint8Array(16);
export default function rng() {
    return crypto.getRandomValues(rnds8);
}
